<!-- ChildComponent.vue -->
<template>
  <v-container fluid class="bg-background ma-0 pt-0">
    <!-- <v-card>
      <v-card-text> -->
    <v-skeleton-loader
      v-if="isLoading"
      type="card"
      class="mb-3"
    ></v-skeleton-loader>

    <v-expansion-panels v-else>
      <v-expansion-panel class="elevation-0">
        <v-expansion-panel-title>{{ name }} | Report</v-expansion-panel-title>
        <v-expansion-panel-text>
          <div
            v-if="
              reportSuccess == false &&
              reportError != null &&
              reportError.length > 0
            "
            class="t-h5Reg"
          >
            <v-row class="align-center" justify="center">
              <v-col cols="12">
                <v-container class="d-flex align-center">
                  {{ reportError }}
                </v-container>
              </v-col>
            </v-row>
          </div>
          <v-card v-else elevation="0" class="px-4 py-1">
            <v-card-text class="">
              <v-row dense justify="space-between" class="align-center">
                <v-col class="mt-5" cols="12" xs="12" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg pa-0 mr-2" cols="auto">
                      Attempted Date
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{
                        item.testInstanceMode == "onlinetest"
                          ? getDateTimeFromTimeStamp(item.startTimeStamp)
                          : "--"
                      }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Test Mode
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      <span
                        v-if="
                          item.testInstanceMode == 'onlinetest' &&
                          item.mode.toLowerCase() == 'practice'
                        "
                      >
                        Practice
                      </span>
                      <span v-else-if="item.testInstanceMode == 'onlinetest'">
                        Online
                      </span>
                      <span v-else-if="item.testInstanceMode == 'offlinetest'">
                        Offline
                      </span>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Status
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.status }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Time Spent
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{
                        item.testInstanceMode == "onlinetest"
                          ? item.timespentInMinutes + " Mins"
                          : "--"
                      }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      No. of Question
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.totalQuestion }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Attempted
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.attemptedQuestions }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Correct Questions
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.correctQuestions }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Incorrect Questions
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.incorrectQuestion }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="6" xs="6" sm="6" md="5" lg="4">
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Total Marks
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.marks }}/{{ item.totalTestMarks }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="
                    testReport.testMode == 'onlineoffline' &&
                    item.testInstanceMode == 'onlinetest'
                  "
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      <span v-if="item.mode == 'Test'"> Online Rank </span>
                      <span v-else> Online Reference Rank </span>
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.onlineRank || "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="
                    testReport.testMode == 'onlineoffline' &&
                    item.testInstanceMode == 'offlinetest'
                  "
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      <span v-if="item.mode == 'Test'"> Offline Rank </span>
                      <span v-else> Offline Reference Rank </span>
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.offlineRank || "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="
                    testReport.testMode == 'onlineoffline' &&
                    item.testInstanceMode == 'offlinetest'
                  "
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Offline Percentile
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.offlineRank ? item.offlinePercentile : "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="
                    testReport.testMode == 'onlineoffline' &&
                    item.testInstanceMode == 'onlinetest'
                  "
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Online Percentile
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.onlineRank ? item.onlinePercentile : "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="testReport.testMode == 'onlineoffline'"
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      <span v-if="item.mode == 'Test'"> Combined Rank </span>
                      <span v-else> Combined Reference Rank </span>
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.combinedRank || "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="testReport.testMode == 'onlineoffline'"
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Combined Percentile
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.combinedRank ? item.combinedPercentile : "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="testReport.testMode == 'online'"
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      <span v-if="item.mode == 'Test'"> Rank </span>
                      <span v-else> Reference Rank </span>
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.rank || "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col
                  class="mt-5"
                  cols="6"
                  xs="6"
                  sm="6"
                  md="5"
                  lg="4"
                  v-if="testReport.testMode == 'online'"
                >
                  <v-row dense class="align-center ma-0 pa-0 mb-2">
                    <v-col class="t-h6Reg ma-0 pa-0 mr-2" cols="auto">
                      Percentile
                    </v-col>
                  </v-row>

                  <v-row dense class="ma-0 pa-0">
                    <v-col class="t-h6 ma-0 pa-0" cols="auto">
                      {{ item.rank ? item.percentile : "--" }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col class="mt-5" cols="12" xs="12" sm="6" md="5" lg="4">
                  <v-btn
                    v-if="item.subjectWiseReports.length > 0"
                    class="btn-rd text-capitalize t-btnSmall subject-report-btn"
                    @click="all"
                    color="primary"
                    variant="outlined"
                    rounded="0"
                    elevation="0"
                  >
                    {{
                      isDropdownVisible
                        ? "Hide Subject-Wise Reports"
                        : "Show Subject-Wise Reports"
                    }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
            <div class="dropdown-subjectwise-marks" v-if="isDropdownVisible">
              <v-data-table
                :headers="headers"
                :items="item.subjectWiseReports"
                class="elevation-1"
                item-key="name"
              >
                <template v-slot:bottom>
                  <div></div>
                </template>
              </v-data-table>
            </div>
          </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <!-- </v-card-text>
    </v-card> -->
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  props: ["id", "name"],
  data: () => ({
    isLoading: true,
    item: null,
    reportSuccess: false,
    reportError: "",
    testReport: {},
    isDropdownVisible: false,
    headers: [
      {
        title: "Subjects",
        align: "start",
        sortable: false,
        key: "subjectName"
      },
      { title: "Total Questions", align: "end", key: "totalQuestions" },
      { title: "Correct Questions", align: "end", key: "correctQuestions" },
      { title: "Incorrect Questions", align: "end", key: "incorrectQuestion" },
      { title: "Skipped Questions", align: "end", key: "skippedQuestions" },
      { title: "Marks Obtained", align: "end", key: "marks" },
      { title: "Combined Rank", align: "end", key: "rank" },
      { title: "Percentage Score", align: "end", key: "percentage" },
      { title: "Combined Percentile", align: "end", key: "percentile" },
      { title: "Total Marks", align: "end", key: "totalSubjectMarks" },
      { title: "Topper Marks", align: "end", key: "topperMarks" }
    ]
  }),
  watch: {
    id: {
      immediate: true,
      handler(id) {
        this.getTestReportsFromServer({ testId: id });
      }
    }
  },
  methods: {
    all() {
      console.log(this.isDropdownVisible);
      if (this.isDropdownVisible) {
        this.isDropdownVisible = false;
      } else {
        this.isDropdownVisible = true;
      }
    },
    getDateTimeFromTimeStamp(timestamp) {
      let date = new Date(timestamp);
      var dateString = moment(date).format("D MMM  YYYY	hh:mm A	");
      return dateString;
    },
    async getTestReportsFromServer(id) {
      this.reportError = "";
      this.isLoading = true;
      this.$store
        .dispatch("getTestReportForCombinedReport", id)
        .then(res => {
          //console.log("Responses in get Test Report for item", res);
          this.testReport = res;
          this.item = res.report ?? [];
          this.item = this.item.filter(i => i.mode === "Test") || [];
          const hasOfflineTest = this.item.some(
            item => item.testInstanceMode === "offlinetest"
          );

          if (hasOfflineTest) {
            this.item = this.item.filter(
              item => item.testInstanceMode === "offlinetest"
            );
          } else {
            this.item = this.item.filter(
              item => item.testInstanceMode === "onlinetest"
            );
          }

          if (this.item.length === 0) {
            this.reportSuccess = false;
            this.reportError = `Test not Attempted`;
            return;
          }

          this.item = this.item[0];
          this.reportSuccess = res.success ?? false;
          let resultAvailable = res.resultAvailable;
          let resultTestTime = res.resultTimestamp;
          if (this.reportSuccess == false) {
            if (resultAvailable == false) {
              this.reportError = `Your Result will be declared on ${this.getDateTimeFromTimeStamp(
                resultTestTime
              )}`;
            } else {
              this.reportError = this.item.errorMessage;
            }
          }
          //console.log("After everything success item is : ", this.item);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    async getTestReport(item) {
      let report = {};
      this.$store.dispatch("getTestReportForCombinedReport", item).then(res => {
        console.log("Responses in get Test Report for item", item.testId, res);
        report = res;
        return res;
      });
      return report;
    }
  }
};
</script>
